export default function Configure($stateProvider) {
    $stateProvider.state('utilisateurs', {
        parent: 'common',
        url: '/utilisateurs',
        //abstract: true,
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            // le state étant parent et abstract, on décide de ne pas l'afficher dans le fil d'ariane
            //skip: true
            label: '{{ "LAYOUT.NAVIGATION.DONNEES_PARAMETRES" | translate }}'
        }
    });

    $stateProvider.state('utilisateurs.list', {
        url: '/:genre/list',
        template: '<personnes></personnes>',
        rights: { domain: 'utilisateurs', right: 'read' },
        ncyBreadcrumb: {
            parent: 'utilisateurs',
            label: '{{ "PERSONNES.BREADCRUMBS.UTILISATEURS_LIST" | translate}}'
        },
        // // on affiche la liste des personnes dans la navigation
        // navigation: {
        //     menu: 'donnees_parametres_donnees',
        //     translate: 'PERSONNES.BREADCRUMBS.PERSONNES_LIST'
        // },
        // // la liste des personnes fait partie des points d'entrée recherchables dans la navigation
        search: 'PERSONNES.BREADCRUMBS.UTILISATEURS_LIST'
    });

    $stateProvider.state('utilisateurs.list.detail', {
        url: '/{id}',
        template: '<personne-detail></personne-detail>',
        //rights: {domain: 'personnel', right: 'read'},
        ncyBreadcrumb: {
            parent: 'utilisateurs.list',
            label: '{{ "PERSONNES.BREADCRUMBS.UTILISATEUR_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('utilisateurs.new', {
        url: '/:genre/new',
        template: '<personnes-form></personnes-form>',
        //rights: {domain: 'personnel', right: 'create'},
        ncyBreadcrumb: {
            // on décide que la liste est le parent des autres states
            // afin d'afficher personnes > ajouter
            parent: 'utilisateurs.list({genre: "utilisateur"})',
            label: '{{ "PERSONNES.BREADCRUMBS.UTILISATEUR_NEW" | translate}}'
        },
        // l'ajout d'un arret fait partie des points d'entrée recherchables dans l'application
        search: 'PERSONNES.BREADCRUMBS.UTILISATEUR_NEW'
    });

    $stateProvider.state('utilisateurs.edit', {
        url: '/:genre/{id}/edit',
        template: '<personnes-form></personnes-form>',
        //rights: {domain: 'personnel', right: 'update'},
        ncyBreadcrumb: {
            // on décide que la liste est le parent des autres states
            // afin d'afficher personnes > modifier
            parent: 'utilisateurs.list({genre: "utilisateur"})',
            label: '{{ "PERSONNES.BREADCRUMBS.UTILISATEUR_EDIT" | translate }}'
        }
    });

    /*$stateProvider.state('utilisateurs.newType', {
        url: '/new-type',
        template: '<type-form></type-form>',
        rights: {domain: 'types', right: 'create'},
        params: {parentState:'utilisateurs.new'},
        ncyBreadcrumb: {
            parent: 'utilisateurs.new({genre: "utilisateur"})',
            label: '{{ "TYPES.BREADCRUMBS.TYPE_NEW" | translate}}'
        }
    });*/
}

Configure.$inject = ['$stateProvider'];
